import React from 'react';
import { connect } from 'react-redux';

import BCLLoading from '../../common/Loading/BCLLoading';
import FooterMain from "../../standalone/common/Footer/FooterMain";
import { setPageTitle } from '../../../helpers/helper';
import { DASHBOARD_SETTINGS_PATH } from '../../../constants/paths';

const PreferencesContent = React.lazy(() => import(/* webpackChunkName: "PreferencesContent" */ '../../standalone/Preferences/PreferenceContent/PreferencesContent'));
class SettingsPreferencesPageMain extends React.Component {
  componentDidMount(){
    setPageTitle("PREFERENCES_PAGE.TITLE", this.props.translations.data, this.props.configs.data);
  }

  render() {
    return (
      <>
        {this.props.userDetails &&
          <React.Suspense fallback={<BCLLoading />}>
            <PreferencesContent userDetails={this.props.userDetails.details} routePath={DASHBOARD_SETTINGS_PATH} />
          </React.Suspense>
        }
        {this.props.configs && this.props.configs.data && this.props.configs.data["DASHBOARD.PREFERENCE_PAGE.FOOTER.SHOW"] === "true" ?
          (<FooterMain configs={this.props.configs} translations={this.props.translations} footerNote={this.props.translations.data["FOOTER.PREFERENCE_PAGE.FOOTER_NOTE"]} />)
        : ''
      }
      </>
    );
  }
}


const mapStateToProps = state => {
  return {
    userDetails: state.userObject,
    configs: state.configs,
    translations: state.translationsData
  }
}

export default connect(mapStateToProps)(SettingsPreferencesPageMain);
